<template>
    <a-modal
        :title="isUpdate ? '修改代理' : '新增代理'"
        :width="640"
        :visible="visible"
        :confirmLoading="loading"
        :maskClosable="false"
        @ok="$emit('ok')"
        @cancel="$emit('cancel')"
    >
        <a-form-model
            ref="agentForm"
            :model="form"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 16 }"
            autocomplete="off"
        >
            <a-form-model-item
                label="地区"
                prop="areaPath"
                :rules="[{ validator: validateArea, trigger: 'change' }]"
            >
                <a-cascader
                    v-model="form.areaPath"
                    :options="areaOptions"
                    :show-search="{ filter }"
                    change-on-select
                    placeholder="点击省可选中全省，再点市可选市"
                    style="width: 100%"
                    @change="onAreaChange"
                />
            </a-form-model-item>

            <a-form-model-item
                label="姓名"
                prop="username"
                :rules="[{ required: true, message: '请输入姓名', trigger: 'blur' }]"
            >
                <a-input v-model.trim="form.username" :maxLength="20" />
            </a-form-model-item>

            <a-form-model-item
                v-if="!isUpdate"
                label="登录账号"
                prop="loginAccount"
                :rules="[
                    { required: true, message: '请输入登录账号', trigger: 'blur' },
                    { validator: validateAccount, trigger: 'blur' }
                ]"
            >
                <a-input v-model.trim="form.loginAccount" :maxLength="30" />
            </a-form-model-item>

            <a-form-model-item
                v-if="!isUpdate"
                label="登录密码"
                prop="loginPassword"
                :rules="[{ required: true, message: '请输入登录密码', trigger: 'blur' }]"
            >
                <a-input v-model="form.loginPassword" />
            </a-form-model-item>

            <a-form-model-item label="备注" prop="remark">
                <a-textarea v-model="form.remark" :maxLength="200" :auto-size="{ minRows: 3, maxRows: 5 }" />
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>

<script>
import { agentAccountIsExist, agentAreaOptions } from '@/api/member/agent';

function emptyForm() {
    return {
        id: 0,
        areaPath: [],
        areaId: undefined,
        username: '',
        loginAccount: '',
        loginPassword: '',
        remark: ''
    };
}

export default {
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        loading: {
            type: Boolean,
            default: false
        },
        model: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            form: emptyForm(),
            areaOptions: [],
            occupiedAreaIds: []
        };
    },
    computed: {
        isUpdate() {
            return Boolean(this.model && this.model.id > 0);
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.initForm();
            }
        }
    },
    methods: {
        initForm() {
            const model = this.model || {};
            const provinceId = model.provinceId || undefined;
            const areaId = model.areaId || undefined;
            let areaPath = [];
            if (areaId) {
                // 有 provinceId 表示绑的是市；否则绑的是整省
                areaPath = provinceId ? [provinceId, areaId] : [areaId];
            }
            this.form = {
                ...emptyForm(),
                id: model.id || 0,
                areaPath,
                areaId,
                username: model.username || '',
                remark: model.remark || ''
            };
            this.fetchAreaOptions().then(() => {
                this.$nextTick(() => {
                    if (this.$refs.agentForm) {
                        this.$refs.agentForm.clearValidate();
                    }
                });
            });
        },
        fetchAreaOptions() {
            const excludeId = this.isUpdate ? this.model.id : 0;
            return agentAreaOptions(excludeId).then(res => {
                this.areaOptions = res.data.options || [];
                this.occupiedAreaIds = (res.data.occupiedAreaIds || []).map(Number);
            });
        },
        onAreaChange(value) {
            if (!value || !value.length) {
                this.form.areaPath = [];
                this.form.areaId = undefined;
                return;
            }
            const path = value.map(Number);
            this.form.areaPath = path;
            const areaId = path[path.length - 1];
            // 占用的省不立刻清空路径，方便继续点下级市；提交时再校验
            this.form.areaId = this.occupiedAreaIds.includes(areaId) ? undefined : areaId;
        },
        validateArea(rule, value, callback) {
            if (!value || !value.length) {
                callback(new Error('请选择地区'));
                return;
            }
            const areaId = Number(value[value.length - 1]);
            if (this.occupiedAreaIds.includes(areaId)) {
                callback(new Error('该地区已有启用中的代理'));
                return;
            }
            callback();
        },
        filter(inputValue, path) {
            return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
        },
        validateAccount(rule, value, callback) {
            if (!value) {
                callback();
                return;
            }
            agentAccountIsExist(value).then(res => {
                if (res.data) {
                    callback(new Error('登录账号已存在'));
                } else {
                    callback();
                }
            }).catch(() => callback());
        }
    }
};
</script>
